type IEnhancement = (text: string) => string;

export const applyStringEnhancements = (text: string, enhancements: [boolean, IEnhancement][]) => {
    return enhancements.reduce((acc, [apply, enhancement]) => (apply ? enhancement(acc) : acc), text);
};
